import { render, staticRenderFns } from "./3PPT.vue?vue&type=template&id=75bb0124&scoped=true&"
import script from "./3PPT.vue?vue&type=script&lang=js&"
export * from "./3PPT.vue?vue&type=script&lang=js&"
import style0 from "./3PPT.vue?vue&type=style&index=0&id=75bb0124&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75bb0124",
  null
  
)

export default component.exports